module.exports = __webpack_public_path__ + "img/bayonetta.f5fa5387.png";